import React from "react";

export const SectionLabel = ({ children, n }) => (
  <div className="flex items-center gap-3 mb-6">
    {n && (
      <span className="font-mono text-xs bg-ink text-paper px-2 py-1 tracking-widest">{n}</span>
    )}
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-ink/60">{children}</span>
    <span className="flex-1 h-[2px] bg-ink/15" />
  </div>
);
